import { PPI_RATIO } from '@/box/constants';

export function scaleToPPI(configuration) {
  if (!configuration || !configuration.canvases || !configuration.canvases.length) {
    console.error('DEBUG: scaleToPPI: Invalid configuration')
    return configuration
  }

  const { canvases } = configuration
  canvases.forEach(canvas => {
    canvas.width = canvas.width * PPI_RATIO
    canvas.height = canvas.height * PPI_RATIO

    if (canvas.objects && canvas.objects.length) {
      canvas.objects.forEach(object => {
        object.scaleX = object.scaleX * PPI_RATIO
        object.scaleY = object.scaleY * PPI_RATIO
        object.left = object.left * PPI_RATIO
        object.top = object.top * PPI_RATIO
        // object.width = object.width * PPI_RATIO
        // object.height = object.height * PPI_RATIO
      })
    }
  })

  return configuration
}

export function scaleToBasePPI(configuration) {
  if (!configuration || !configuration.canvases || !configuration.canvases.length) {
    console.error('DEBUG: scaleToBasePPI: Invalid configuration')
    throw new Error('Invalid configuration')
  }

  const { canvases } = configuration
  canvases.forEach(canvas => {
    canvas.width = canvas.width / PPI_RATIO
    canvas.height = canvas.height / PPI_RATIO

    if (canvas.objects && canvas.objects.length) {
      canvas.objects.forEach(object => {
        object.scaleX = object.scaleX / PPI_RATIO
        object.scaleY = object.scaleY / PPI_RATIO
        object.left = object.left / PPI_RATIO
        object.top = object.top / PPI_RATIO
        // object.width = object.width / PPI_RATIO
        // object.height = object.height / PPI_RATIO
      })
    }
  })

  return configuration
}
